import { FlatList } from 'react-native';
import { Searchbar } from 'react-native-paper';
import Color from 'color';
import styled from 'styled-components/native';

import Image from '@src/components/Image';
import Row from '@src/components/Row';
import Separator from '@src/components/Separator';
import {
  idKeyExtractor,
  padding,
  windowWidth,
} from '@src/configuration/constants';
import { TourSummery } from '@src/types';

export const ItemsContainer = styled.View`
  padding: 0 ${padding}px;
`;
export const ImageIcon = styled(Image)`
  width: 24px;
  height: 24px;
`;

export const SearchBar = styled(Searchbar).attrs(({ theme }) => ({
  iconColor: Color(theme.colors.placeholder).lighten(0.2).hex(),
  placeholderTextColor: Color(theme.colors.placeholder).darken(0.2).hex(),
}))`
  elevation: 0;
  min-width: ${windowWidth / 2}px;
  width: 100%;
  height: 80%;
  max-height: 50px;
  background-color: ${({ theme }) =>
    Color(theme.colors.surface).darken(0.05).hex()};
`;

export const SearchContainer = styled(Row)`
  height: 64px;
  padding-horizontal: ${padding / 2}px;
  border-radius: 8px;
  margin-vertical: ${padding}px;
`;

export const List = styled(FlatList as new () => FlatList<TourSummery>).attrs(
  () => ({
    removeClippedSubviews: true,
    initialNumToRender: 6,
    scrollEventThrottle: 6,
    keyExtractor: idKeyExtractor,
    showsHorizontalScrollIndicator: false,
    ItemSeparatorComponent: Separator,
    contentContainerStyle: {
      paddingBottom: padding,
      marginHorizontal: padding / 2,
    },
  })
)``;
